import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '@shared/shared.module';
import { QuestionnaireModule } from './questionnaire/questionnaire.module';
import { QuestionnaireDialogModule } from './questionnaire-dialog/questionnaire-dialog.module';
import { QuestionnairesComponent } from './questionnaires.component';


@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    QuestionnaireModule,
    SharedModule,
    QuestionnaireDialogModule
  ],
  declarations: [QuestionnairesComponent]
})
export class QuestionnairesModule { }
